/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IColumnas from './entidades/columnas';
import IFiltrosColumnas from './entidades/filtrosColumnas';

export default class ModeloColumnas {
    public consultarColumnas() {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocio.get('Columna/ConsultarListaColumna'), true);
    }
    public crearColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocio.post('Columna/GuardarColumna', columnas), true);
    }
    public editarColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocio.put('Columna/EditarColumna', columnas), true);
    }
    public eliminarColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocio.delete('Columna/EliminarColumna', columnas), true);
    }
    public consultarListaColumnasPorFiltro(filtrosColumnas: Partial<IFiltrosColumnas>) {
        return manejadorRest<IRespuesta<IColumnas>>(
            () => negocio.post('Columna/ConsultarListaColumnaPorFiltro', filtrosColumnas),
            true
        );
    }
}
